module.exports = __webpack_public_path__ + "static/media/JO.8fa47fe7.svg";